// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__ZxVy2","page-container":"Contact_page-container__MUkY1","footer":"Contact_footer__hX-vL"};